let protocol = window.location.protocol;

let pointPosition = window.location.hostname.indexOf('.');
let subdomain = window.location.hostname.substr(0, pointPosition > 0 ? pointPosition : undefined);
let apiSubdomain = subdomain + '-api';
let apiHost = window.location.hostname.replace(subdomain, apiSubdomain);
let withDev = '';

if (window.location.hostname.indexOf('cobweb') !== -1) {
    withDev = '/app_dev.php';
}

if (window.location.hostname === 'localhost') {
    withDev = '/app_dev.php';
    apiHost = 'fog.ddev.site';
    protocol = 'https:'
}

export const GRAPHQL_ROUTE = protocol + '//' + apiHost + withDev + '/fetch';
export const API_ROUTE = protocol + '//' + apiHost + withDev;


/*export const GRAPHQL_ROUTE = 'http://fog-api.cobweb.j0n.io/app_dev.php/fetch';
export const API_ROUTE = 'http://fog-api.cobweb.j0n.io/app_dev.php/';*/

/**
 * Si c'est de la préprod ou de la prod, on rajoute -api au nom de domaine en cours
 * si c'est du localhost l'url (en dev local avec yarn start), on pointe vers fog-api.cobweb.local
 **/


// WEBPACK FOOTER //
// ./src/constants/ajaxRoutes.js